export default {
  placeholder: 'Vybrať skupinu tried ocele',
};
